module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "example-2",
      "dark": "",
      "toolbar": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "clipped": "",
      "persistent": "",
      "dark": "",
      "mini-variant": _vm.mini,
      "overflow": ""
    },
    on: {
      "update:miniVariant": function($event) {
        _vm.mini = $event
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('sidebar')], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "fixed": ""
    }
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v("QikByte")])], 1), _vm._v(" "), _c('main', {
    staticClass: "one"
  }, [_c('messages')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a0f8116","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dash.vue
// module id = 220
// module chunks = 1